import { MotifButton, MotifFileUploaderItem, MotifFormField, MotifIcon, MotifInput, MotifLabel, MotifModal, MotifModalBody, MotifModalFooter, MotifModalHeader, MotifOption, MotifSelect } from '@ey-xd/motif-react'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const WorkspaceEditDocumentVersion = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const { workspaceId } = params;
    const { dialogDetails } = useSelector((state: any) => state.workspaces);
    const [open, setOpen] = React.useState(false);
    const [activeStatus, setActiveStatus] = React.useState(dialogDetails?.status);
    const toggleDialogOpen = () => {
        if(open === true) {
            dispatch({type: "CLOSE_WORKSPACE_DIALOG"})
        }
        setOpen(!open)
    }
    const handleConfirm = () => {
        dispatch({
            type: "WORKSPACE_EDIT_VERSION_DOCUMENT",
            payload: {
                versionId: dialogDetails?.versionId,
                status: activeStatus,
                workspaceId
            }
        })
        toggleDialogOpen();
    }
    useEffect(() => {
        if(dialogDetails && dialogDetails.dialogType === "EDIT_DOCUMENT_VERSION") {
            setOpen(true)
            setActiveStatus(dialogDetails.status)
        }
    }, [dialogDetails])

    const statusChangeHandler = (value: any) => {
        setActiveStatus(value);
    }
    return (
        <MotifModal
            onClose={toggleDialogOpen}
            show={open}
        >
            <MotifModalHeader
            >
                <h5>Editing {dialogDetails?.versionNumber} </h5>
            </MotifModalHeader>
            <MotifModalBody>
                <div className="flex flex-col gap-3">
                    <h5>You can update the status:</h5>
                    <div>

                    </div> <div className="motif-row gap-y-5">
                        <div className="otif-col-1 motif-col-lg-6">
                            <MotifFormField>
                                <MotifInput
                                    placeholder="Version numeber"
                                    value={dialogDetails?.versionNumber}
                                    disabled
                                    hideClearButton
                                />
                            </MotifFormField>
                        </div>
                        <div className="otif-col-1 motif-col-lg-6">
                            <MotifFormField>
                                <MotifSelect
                                    onChange={statusChangeHandler}
                                    placeholder="select"
                                    value={activeStatus}
                                    visibleOptions={3}
                                >
                                    <MotifOption value="Published">
                                        Published
                                    </MotifOption>
                                    <MotifOption value="Inactive">
                                        Inactive
                                    </MotifOption>

                                </MotifSelect>
                            </MotifFormField>
                        </div>
                        <div className="otif-col-1 motif-col-lg-12">
                            <div>
                                <MotifFileUploaderItem
                                    fileIcon={<MotifIcon src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTQgMkg2Yy0xLjEgMC0xLjk5LjktMS45OSAyTDQgMjBjMCAxLjEuODkgMiAxLjk5IDJIMThjMS4xIDAgMi0uOSAyLTJWOGwtNi02em0yIDE2SDh2LTJoOHYyem0wLTRIOHYtMmg4djJ6bS0zLTVWMy41TDE4LjUgOUgxM3oiLz48L3N2Zz4=" />}
                                    fileName={dialogDetails?.documentName}
                                />
                            </div>
                        </div>
                    </div>
                </div>            </MotifModalBody>
            <MotifModalFooter style={{ borderTop: "1px solid #ffffff26" }} className="!pb-0">
                <div className="flex gap-3 justify-end items-center my-4">
                    <MotifButton
                        onClick={toggleDialogOpen}
                        size="medium"
                        type="button"
                        variant="secondary"
                    >
                        Cancel
                    </MotifButton>
                    <MotifButton
                        className="!mt-0"
                        disabled={activeStatus === dialogDetails?.status}
                        onClick={handleConfirm}
                        size="medium"
                        type="button"
                    >
                        Confirm
                    </MotifButton>
                </div>
            </MotifModalFooter>
        </MotifModal>
    )
}

export default WorkspaceEditDocumentVersion